import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Input, Form, Row, Col, Space, Button } from 'antd';
import { notification } from 'antd';

import PhoneInputFormItem from '@controls/phone-input-form-item/phone-input-form-item';
import FormHeader from '@controls/form-header/form-header';

import { exception } from '@extensions/notification';
import { userLoaded } from '@store/actions';
import { serverFetch } from '@src/server';

import { useAppDispatch } from '@store/hooks';
import { ITruck } from '@entities/truck';
import { TruckType } from '@enums/truck-type';
import { TruckStatus, enumLabel } from '@enums/truck-status';

//import '../warehouse.css';

const dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

const Truck = () => {
    const { journalId, truckId } = useParams();
    const [api, contextHolder] = notification.useNotification();

    const { TextArea } = Input;

    const d = useAppDispatch();
    const navigate = useNavigate();

    const [entity, setEntity] = useState<ITruck>();
    const [isViewOnly, setIsViewOnly] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        initData();
    }, []);

    useEffect(() => {
        setIsViewOnly(entity?.status === TruckStatus.Finished);
    }, [entity]);

    const initData = async () => {
        if (!truckId) {
            setEntity({
                id: undefined,
                number: undefined,
                departureOn: undefined,
                type: TruckType.Delivery,
                status: TruckStatus.New,
            });
            return;
        }

        setLoading(true);

        serverFetch(`trucks/${truckId}`, { method: 'GET' })
            .then((data) => {
                setEntity(data);
                setLoading(false);
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка получения машины', ex, () => d(userLoaded(undefined)));
            });
    };

    const onFinish = (data: any) => {
        if (!entity) return;

        setLoading(true);

        let result = { ...entity, ...data, journalId: journalId };

        serverFetch(`trucks`, { method: truckId ? 'PUT' : 'POST', bodyData: result })
            .then(() => {
                setLoading(false);
                navigate(-1);
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка сохранения машины', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <>
            <Row>
                <FormHeader title={`${truckId ? 'Управление машиной' : 'Добавить машину'}`} />
            </Row>

            {entity && (
                <>
                    <Row>
                        <Col span={12}>
                            <Form colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 10 }} onFinish={onFinish}>
                                <Form.Item
                                    initialValue={entity?.number}
                                    required={true}
                                    label='Номер машины'
                                    name='number'
                                    rules={[{ required: true, message: 'Укажите номер машины' }]}
                                    wrapperCol={{ span: 5 }}
                                >
                                    <Input
                                        disabled={isViewOnly}
                                        autoFocus
                                        onChange={(data) => {
                                            if (!entity) return;

                                            setEntity({ ...entity, number: data.target.value });
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label='Статус' wrapperCol={{ span: 5 }}>
                                    <Input disabled={true} defaultValue={enumLabel(entity?.status)} />
                                </Form.Item>
                                <PhoneInputFormItem
                                    value={entity?.driverPhone}
                                    name='driverPhone'
                                    label='Телефон водителя'
                                    required={true}
                                    disabled={isViewOnly}
                                    onChange={(value) => {
                                        setEntity({ ...entity, driverPhone: value });
                                    }}
                                />
                                <Form.Item initialValue={entity?.trackingUrl} label='Трекинг URL' name='trackingUrl'>
                                    <Input
                                        disabled={isViewOnly}
                                        onChange={(data) => {
                                            if (!entity) return;

                                            setEntity({ ...entity, trackingUrl: data.target.value });
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label='Комментарий' name='comment' initialValue={entity?.comment}>
                                    <TextArea
                                        disabled={isViewOnly}
                                        rows={4}
                                        onChange={(data) => {
                                            setEntity({ ...entity, comment: data.target.value });
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
                                    <Space size={'small'} style={{ float: 'right' }}>
                                        <Button type='text' onClick={() => navigate(-1)}>
                                            Закрыть
                                        </Button>
                                        {!isViewOnly && (
                                            <Button type='primary' htmlType='submit' loading={loading}>
                                                Сохранить
                                            </Button>
                                        )}
                                    </Space>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </>
            )}

            {contextHolder}
        </>
    );
};

export default Truck;
